import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import * as Actions from '../store/actions';
import * as LabelActions from '../../content_label/store/actions';
import * as QuestionActions from 'main/content/question/store/actions';
import { FusePageCarded } from '@fuse';
import { getSharedTextFieldProps } from '../../../components/helpers'
import {
    Card,
    AppBar,
    Typography,
    Button,
    Icon,
    CardContent,
    Grid,
    Tooltip,
    DialogTitle,
    DialogContent,
    DialogActions,
    Dialog,
    Tabs,
    Tab,
    Hidden,
    TextField,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import QuestionEdit from './QuestionEdit';
import QuizForm from './QuizForm';
import FlipMove from 'react-flip-move';
import CourseBuilderHeader from '../../../components/CourseBuilderHeader';
import TabPanelButtons from 'main/components/TabPanelButtons';
import * as paramActions from '../../../components/paramHistory/store/actions';
import _ from 'lodash';
import PageHeader from 'main/components/PageHeader';
import EventUsage from 'main/components/event/EventUsage';
import EventUsageDialog from 'main/components/event/EventUsageDialog';
import RelationUpdateTabs from '../../../components/RelationUpdateTabs';
import StaticRelationList from '../../../components/StaticRelationList';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    button: {
        margin: theme.spacing.unit,
    },
});

class QuizBuilder extends Component {
    state = {
        quiz_id: 0,
        view_type: '',
        scroll_to: null,
        current_tab: 0,
        deleteDialogActive: false,
        copyDialogActive: false,
        usageDialogActive: false,
        lockDialogActive: false,
        unlockDialogActive: false,
        saveDialogActive: false,
        activateDialogActive: false
    }

    constructor(props) {
        super(props);

        this.state.quiz_id = this.props.match.params.quiz_id;
        this.state.view_type = this.props.match.params.view_type;

        this.scrollToRef = React.createRef();
    }

    componentDidMount = () => {
        this.props.getQuestionTypes();
        this.props.getLabels();

        if (this.state.view_type === 'create') {
            this.props.clearQuiz();
            this.props.getCompanyList();
        } else {
            this.props.getQuiz(this.state.quiz_id);
            this.props.getEditInfo(this.state.quiz_id)
        }
    }

    handleBack = () => {
        const { paramHistory } = this.props;
        if (paramHistory.lessonCycleActive) {
            return this.props.history.push('/lesson/edit/' + paramHistory.lesson_id)
        }
        else {
            this.props.updatePageHeader({ LessonName: '', lessonCycleActive: false, active: false });
            this.props.toggleQuizRepull(true)
            return this.props.history.goBack();
        }

    }

    handleSaveDialogCheckUsage = () => {
        const { event_usage } = this.props;

        if (typeof event_usage !== 'undefined' && event_usage.event_list.length > 0) {
            this.setState({
                usageDialogActive: true
            })
        } else {
            this.handleSave('not_in_use');
        }
    }

    handleSaveDialogCheckZeroPoints = () => {
        const { quiz } = this.props;

        const questionList = quiz.questionList;

        if (questionList.filter(q => Number(q.header.Score) === 0).length > 0) {
            this.setState({ saveDialogActive: true });
            return true
        }

        return this.handleSaveDialogCheckUsage();
    }

    handleSave = (event_course_status) => {
        const { view_type } = this.state;
        const { event_usage } = this.props;
        const builderActive = this.props.paramHistory.active;
        const lesson_id = this.props.paramHistory.lesson_id;
        const auth_id = this.props.auth.user.data.auth_id;

        switch (view_type) {
            case ("edit"):
                {
                    this.props.updateQuizListLoaded(false);
                    this.props.saveQuiz(this.props.quiz, auth_id, event_course_status, this.props.companies);
                    if (builderActive) {
                        this.props.history.push('/lesson/edit/' + lesson_id);
                    } else {
                        this.props.history.push('/quiz/list');
                    }
                    break;
                }

            case ("create"):
                {
                    this.props.updateQuizListLoaded(false);
                    this.props.saveQuiz(this.props.quiz, auth_id, event_course_status, this.props.companies);
                    if (builderActive) {
                        this.props.history.push('/lesson/edit/' + lesson_id);
                    } else {
                        this.props.history.push('/quiz/list');
                    }
                    break;
                }

            default: { }
        }
    }

    handleChangeTab = (event, value) => {
        this.setState({
            current_tab: value
        });
    }

    handleChange = (field_name) => (event) => {
        const { quiz, updateQuizBuilder } = this.props;

        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        updateQuizBuilder(update_data);
    }

    handleActivateDialogOpen = () => {
        this.setState({ activateDialogActive: true });
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true });
    }

    handleTestQuiz = () => {
        const { quiz } = this.props;

        this.props.history.push('/quiz/test/' + quiz.header.quiz_id);
    }

    handleLockDialogOpen = () => {
        this.setState({ lockDialogActive: true });
    }

    handleUnlockDialogOpen = () => {
        this.setState({ unlockDialogActive: true });
    }

    handleActivate = () => {
        this.props.activateQuiz(this.props.quiz.header.quiz_id, this.props.auth.user.data.auth_id, this.props.lessons);
        this.setState({ activateDialogActive: false });
        return true
    }

    handleDelete = () => {
        const builderActive = this.props.paramHistory.active;
        const lesson_id = this.props.paramHistory.lesson_id;
        const quiz_id = this.props.quiz.header.quiz_id;
        this.props.updateQuizListLoaded(false);

        this.props.deleteQuizBuilder(quiz_id);
        if (builderActive) {
            this.props.history.push('/lesson/edit/' + lesson_id);
        }
        else {
            this.props.history.push('/quiz/list');
        }
    }

    handleAddQuestion = (quiz_id) => (event) => {
        this.props.addQuestion(quiz_id, this.setScrollTo);
    }

    setScrollTo = (question_id) => {
        this.setState({
            ...this.state,
            scroll_to: question_id
        });
    }

    componentDidUpdate = () => {
        const { quiz } = this.props;

        if (this.state.scroll_to !== null) {
            const ref = ReactDOM.findDOMNode(this.scrollToRef.current);

            if (ref !== null) {
                // ref.scrollIntoView(); // Disabled due to wierd double scroll; not sure what caused this;
            }

            this.state.scroll_to = null;
        }

        if (!_.isEqual(parseInt(this.props.match.params.quiz_id), quiz.header.quiz_id) && this.props.repullQuiz) {
            this.props.getQuiz(this.props.match.params.quiz_id);
            this.props.getEditInfo(this.props.match.params.quiz_id)

            this.setState({
                ...this.state,
                current_tab: 0,
                copyDialogActive: false
            })
            this.props.toggleQuizRepull(false)
        }
    }

    balanceQuestionPoints = () => {
        this.props.autoCalcQuestionPoints();
    }

    handleLock = () => {
        this.props.lockQuiz(this.props.quiz.header.quiz_id, this.props.auth.user.data.auth_id);
        this.setState({ lockDialogActive: false });
        return true
    }

    handleUnlock = () => {
        this.props.unlockQuiz(this.props.quiz.header.quiz_id);
        this.setState({ unlockDialogActive: false });
        return true
    }

    getSaveDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ saveDialogActive: false })}
            >
                <DialogTitle>Question(s) assigned 0 points.</DialogTitle>
                <DialogContent>
                    Please assign points so you can save quiz.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ saveDialogActive: false })} color="primary" autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getActivateDialog = (active, quiz) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ activateDialogActive: false })}
            >
                <DialogTitle>Confirm Activate {quiz.header.QuizName}?</DialogTitle>
                <DialogContent>
                    {this.props.deleteAllowed ? null :
                        <React.Fragment>
                            <Typography variant="h6">It will be deleted from the following:</Typography>
                            {this.props.lessons.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Lessons</Typography>
                                    <Grid container spacing={8}>
                                        {this.props.lessons.map(l => {
                                            return (
                                                <React.Fragment key={l.lesson_id}>
                                                    {l.conflict ?
                                                        <React.Fragment>
                                                            <Grid item xs={1}>
                                                                <Tooltip
                                                                    style={{ display: 'block' }}
                                                                    title={
                                                                        <React.Fragment>
                                                                            <div>This Lessons's Quiz will be overwritten</div>
                                                                            <div>{l.conflict[0].QuizName}</div>
                                                                        </React.Fragment>
                                                                    }
                                                                >
                                                                    <Icon>error</Icon>
                                                                </Tooltip>
                                                            </Grid>
                                                            <Grid item xs={11}>
                                                                <Typography variant="body1" >{l.LessonName}</Typography>
                                                            </Grid>
                                                        </React.Fragment>
                                                        :
                                                        <Grid item xs={12}>
                                                            <Typography variant="body1" >{l.LessonName}</Typography>
                                                        </Grid>
                                                    }
                                                </React.Fragment>

                                            )
                                        })}
                                    </Grid>
                                </React.Fragment>
                                : null
                            }
                            {this.props.events.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Calendars</Typography>
                                    {this.props.events.map(e => {
                                        return (
                                            <Typography variant="body" key={e.company_calendar_event_id}>{e.CompanyName}, Instances: {e.Instances}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                        </React.Fragment>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleActivate()} color="primary">
                        Activate
                        </Button>
                    <Button onClick={() => this.setState({ activateDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getDeleteDialog = (active, quiz) => {
        console.log(this.props)
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle>Confirm Deactivate {quiz.QuizName}?</DialogTitle>
                <DialogContent>
                    {this.props.deleteAllowed ? null :
                        <React.Fragment>
                            <Typography variant="h6">The following relationships will be deactivated:</Typography>
                            {this.props.lessons.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Lessons</Typography>
                                    {this.props.lessons.map(l => {
                                        return (
                                            <Typography variant="body" key={l.lesson_id}>{l.LessonName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                            {this.props.events.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Calendars</Typography>
                                    {this.props.events.map(e => {
                                        return (
                                            <Typography variant="body" key={e.company_calendar_event_id}>{e.CompanyName}, Instances: {e.Instances}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                        </React.Fragment>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Deactivate
                    </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getLockDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ lockDialogActive: false })}
            >
                <DialogTitle>Lock Quiz?</DialogTitle>
                <DialogContent>
                    Only you and Company Admin level users will be able to edit the quiz.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleLock()} color="primary">
                        Lock
                        </Button>
                    <Button onClick={() => this.setState({ lockDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getUnlockDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ unlockDialogActive: false })}
            >
                <DialogTitle>Unlock Quiz?</DialogTitle>
                <DialogContent>
                    All company instructors will be able to edit this quiz.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleUnlock()} color="primary">
                        Unlock
                        </Button>
                    <Button onClick={() => this.setState({ unlockDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getCopyDialog = (active, assignment) => {
        return (
            <Dialog
                maxWidth='md'
                fullWidth
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ copyDialogActive: false })}
            >
                <DialogTitle>Choose a new name</DialogTitle>

                <TextField
                    style={{ width: '80%' }}
                    required
                    id="NewQuizName"
                    label="New Quiz Name"
                    value={this.props.NewQuizName}
                    onChange={(e) => this.props.updateNewQuizName(e.target.value)}
                    // error={validator.filter(v => v.field_name === 'AssignmentName')[0].error}
                    // helperText={validator.filter(v => v.field_name === 'AssignmentName')[0].error_msg}
                    {...getSharedTextFieldProps(this.state.view_type, this.props.classes)}
                />

                <DialogActions>
                    <Button onClick={() => this.props.saveQuizCopy(
                        {
                            ...this.props.quiz,
                            header: {
                                ...this.props.quiz.header,
                                QuizName: this.props.NewQuizName,
                                quiz_id: 0,
                                CopiedFromID: this.props.quiz.header.quiz_id,
                                companies: this.props.companies.map(c => {
                                    return {
                                        company_id: c.id
                                    }
                                })
                            }
                        },
                        this.props.auth.user.data.auth_id,
                        this.props.companies
                    )} color="primary">
                        Create Copy
                    </Button>

                    <Button onClick={() => this.setState({ copyDialogActive: false })} color="primary" autoFocus>
                        Back
                    </Button>
                </DialogActions>

            </Dialog>
        )
    }

    handleCompanySearchChange = (e) => {
        this.props.companyUpdateSearch(e.target.value)
    }

    getPageContent = (current_tab, view_type) => {
        const { classes, quiz, event_usage, theme } = this.props;

        switch (current_tab) {
            case (0): // Detail
                {
                    return (
                        <QuizForm
                            quiz={quiz}
                            view_type={view_type}
                            editInfo={this.props.editInfo}
                            copiedQuiz={this.props.copiedQuiz}
                            event_usage={this.props.event_usage}
                        />
                    );
                }

            case (1): // Question List
                {
                    const question_point_total = quiz.questionList.reduce((total, question) => {
                        return Number(total) + Number(question.header.Score);
                    }, 0);

                    return (
                        <React.Fragment>
                            <AppBar position="static">
                                <div className="p-16 pr-4 flex flex-row items-center justify-between">
                                    <Typography className="h1 pr-16" color="inherit">Question Builder</Typography>

                                    <Typography className="h3 pr-16" color="inherit">
                                        Quiz Points: {Number(question_point_total).toFixed(1) + " / " + Number(quiz.header.TotalScore).toFixed(1)}
                                    </Typography>

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={(quiz.header.auto_calc_points === 1 || quiz.header.auto_calc_points === true)}
                                                onChange={this.handleChange('auto_calc_points')}
                                                value="auto_calc_points"
                                                style={{ color: 'white' }}

                                            />
                                        }
                                        label={<Typography style={{ color: 'white' }}>Auto Calculate Question Points</Typography>}
                                        disabled={view_type === 'detail'}
                                    />

                                    <Tooltip title="Add new Question">
                                        <Button
                                            variant="fab"
                                            color="secondary"
                                            aria-label="Add new Question"
                                            className={classes.button}
                                            onClick={this.handleAddQuestion(quiz.header.quiz_id)}
                                            mini
                                            disabled={view_type === 'detail'}
                                        >
                                            <Icon>add</Icon>
                                        </Button>
                                    </Tooltip>
                                </div>
                            </AppBar>
                            <FlipMove>
                                {quiz.questionList.map((question, index) =>
                                    <QuestionEdit
                                        scrollToRef={question.header.question_id === this.state.scroll_to ? this.scrollToRef : null}
                                        key={question.header.question_id}
                                        question={question}
                                        view_type={view_type}
                                    />
                                )}
                            </FlipMove>
                        </React.Fragment>
                    );
                }
            case (2):
                {
                    return (
                        <EventUsage
                            view_type={view_type}
                            event_usage={event_usage}
                        />
                    )
                }
            case (3): // Company
                {
                    return (
                        view_type === 'detail' ?
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <StaticRelationList
                                        rootClass={classes.root}
                                        items={this.props.companies}
                                        header='Companies'
                                    />
                                </Grid>
                            </Grid>
                            :
                            <RelationUpdateTabs
                                currentRelationsTabData={this.props.companies}
                                handleDelete={this.props.toggleCompany}
                                availableObjectList={this.props.allCompanies}
                                handleAdd={this.props.toggleCompany}
                                handleSearchChange={this.handleCompanySearchChange}
                                search={this.props.companySearch}
                                leftHeader="Current Companies"
                                rightHeader="All Companies"
                                view_type={view_type}
                                rootClass={classes.root}
                                dir={theme.direction}
                            />
                    );
                }
            default: { }
        }
    }

    getLockButtonDisplay = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;
        // early return if its already locked
        if (this.props.quiz.header.IsLocked === 1) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return true;
        }
        else if (role === 'instructor' && auth_id === this.props.quiz.header.CreateAuthID) {
            return true;
        }
        return false;
    }

    getUnlockButtonDisplay = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;
        // early return if its not locked
        if (this.props.quiz.header.IsLocked === 0) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return true;
        }
        else if (role === 'instructor' && auth_id === this.props.quiz.header.CreateAuthID) {
            return true;
        }
        return false;
    }

    hideLockedQuizActions = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;

        if (this.props.quiz.header.IsLocked === 0) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return false;
        }
        else if (role === 'instructor' && auth_id === this.props.quiz.header.LockedByAuthID) {
            return false;
        }
        return true;
    }

    quizCopy = () => {
        // this.props.saveQuizCopy(this.props.quiz, this.props.auth_id)
        this.setState({ copyDialogActive: true })
    }

    render() {
        const { classes, quiz } = this.props;
        const { view_type, current_tab } = this.state;

        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.quiz.header);
        const copy_dialog = this.getCopyDialog(this.state.copyDialogActive, this.props.quiz);
        const lock_dialog = this.getLockDialog(this.state.lockDialogActive);
        const unlock_dialog = this.getUnlockDialog(this.state.unlockDialogActive);
        const save_dialog = this.getSaveDialog(this.state.saveDialogActive);
        const activate_dialog = this.getActivateDialog(this.state.activateDialogActive, this.props.quiz)
        const authRole = this.props.auth.user.data.role_info.role_id;

        const deleteTooltipContent =
            <React.Fragment>
                {this.props.lessons ? this.props.lessons.length > 0 : 0 ? <h5>Lessons depending on this quiz:</h5> : null}
                {this.props.lessons.map(l => {
                    return (
                        <div key={l.lesson_id}>{l.LessonName}</div>
                    )
                })}
                {this.props.events.length > 0 ? <h5>Calendars with this quiz:</h5> : null}
                {this.props.events.map(e => {
                    return (
                        <div key={e.company_calendar_event_id}>{e.CompanyName}, Instances: {e.Instances}</div>
                    )
                })}
            </React.Fragment>

        let page_content = this.getPageContent(current_tab, view_type);
        let header_content = (
            <PageHeader
                component_name={quiz.header.QuizName}
                component_type={"quiz"}
                view_type={view_type}
            />
        )

        if (this.props.paramHistory.active) {
            header_content = <CourseBuilderHeader activeStep={2} baseComponent={'event'} />
        }
        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={header_content}
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Questions"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Editing Conflicts"
                                    disabled={view_type === 'create'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Company"
                                    // disabled={view_type === 'create'}
                                    hidden={authRole > 2}
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name={"quiz"}
                                view_type={view_type}
                                button_list={[
                                    {
                                        display: "unlock",
                                        type: "lock",
                                        onClick: this.handleUnlockDialogOpen,
                                        hidden: !this.getUnlockButtonDisplay() || view_type != 'edit'
                                    },
                                    {
                                        display: "lock",
                                        type: "lock",
                                        onClick: this.handleLockDialogOpen,
                                        hidden: !this.getLockButtonDisplay() || view_type != 'edit'
                                    },
                                    {
                                        display: "Copy",
                                        type: "read",
                                        onClick: this.quizCopy,
                                        hidden: view_type === 'create'
                                    },
                                    {
                                        display: "Test",
                                        type: "read",
                                        onClick: this.handleTestQuiz
                                    },
                                    {
                                        display: "Save",
                                        type: view_type === 'create' ? 'create' : 'update',
                                        onClick: this.handleSaveDialogCheckZeroPoints,
                                        hidden: this.hideLockedQuizActions()
                                    },
                                    {   
                                        display: 'deactivate',
                                        type: "delete",
                                        onClick: this.handleDeleteDialogOpen,
                                        largeLabel: true,
                                        // disabled: !this.props.deleteAllowed,
                                        // tooltip: { active: !this.props.deleteAllowed, content: deleteTooltipContent },
                                        hidden: this.hideLockedQuizActions() || this.props.quiz.header.Active === 0
                                    },
                                    {
                                        type: "activate",
                                        largeLabel: true,
                                        onClick: this.handleActivateDialogOpen,
                                        // disabled: !this.props.deleteAllowed,
                                        hidden: this.hideLockedQuizActions() || this.props.quiz.header.Active === 1

                                    },
                                    {
                                        type: "back",
                                        onClick: () => this.handleBack(),
                                    }
                                ]}
                            />
                        </Grid>
                    </div>
                }
                content={
                    <div className="p-24 h-full">
                        <EventUsageDialog
                            event_usage={this.props.event_usage}
                            active={this.state.usageDialogActive}
                            onCloseDialog={() => this.setState({ usageDialogActive: false })}
                            onSubmitDialog={(event_course_status) => this.handleSave(event_course_status)}
                        />
                        {unlock_dialog}
                        {lock_dialog}
                        {delete_dialog}
                        {copy_dialog}
                        {save_dialog}
                        {page_content}
                        {activate_dialog}
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getQuiz: Actions.getQuiz,
        saveQuiz: Actions.saveQuiz,
        addQuestion: Actions.addQuestion,
        clearQuiz: Actions.clearQuiz,
        deleteQuizBuilder: Actions.deleteQuizBuilder,
        getQuestionTypes: QuestionActions.getQuestionTypes,
        getEditInfo: Actions.getEditInfo,
        updatePageHeader: paramActions.updateCourseBuilderParams,
        saveQuizCopy: Actions.saveQuizCopy,
        updateNewQuizName: Actions.updateNewQuizName,
        toggleQuizRepull: Actions.toggleQuizRepull,
        autoCalcQuestionPoints: Actions.autoCalcQuestionPoints,
        updateQuizBuilder: Actions.updateQuizBuilder,
        lockQuiz: Actions.lockQuiz,
        unlockQuiz: Actions.unlockQuiz,

        companyUpdateSearch: Actions.companyUpdateSearch,
        toggleCompany: Actions.toggleCompany,
        updateQuizListLoaded: Actions.updateQuizListLoaded,

        getLabels: LabelActions.getContentLabelList,
        getCompanyList: Actions.getCompanyList,
        activateQuiz: Actions.activateQuiz
    }, dispatch);
}

function mapStateToProps({ quizApp, questionApp, paramHistory, auth }) {
    return {
        quiz: quizApp.quizzes.currentQuiz,
        questionTypes: questionApp.questions.questionTypes,
        paramHistory: paramHistory.courseBuilder,
        auth: auth,
        editInfo: quizApp.quizzes.editInfo,
        events: quizApp.quizzes.events,
        lessons: quizApp.quizzes.lessons,
        deleteAllowed: quizApp.quizzes.deleteAllowed,
        NewQuizName: quizApp.quizzes.NewQuizName,
        repullQuiz: quizApp.quizzes.repullQuiz,
        copiedQuiz: quizApp.quizzes.copiedQuiz,
        event_usage: quizApp.quizzes.event_usage,

        companies: quizApp.quizzes.companies,
        companySearch: quizApp.quizzes.companySearch,
        allCompanies: quizApp.quizzes.allCompanies
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizBuilder)));



// WEBPACK FOOTER //
// src/main/content/quiz/quizBuilder/QuizBuilder.js